// 게임 설정 단일 소유자
//
// **왜 컨텍스트로 승격했나 — 「옮긴 위치가 저장이 안 된다」의 진범.**
// useGameSettings() 는 훅이라 부르는 곳마다 **독립된 state 를 하나씩 만든다.** 그런데
// 여태 두 곳이 각자 불렀다 — GameEntry(HUD 위젯 좌표를 쓰는 쪽)와 GameConfigContext
// (이동속도만 쓰는 쪽). 둘은 서로의 변경을 못 본다.
//
// 그래서 이런 일이 났다:
//   ① 위젯을 끌어 옮긴다 → GameEntry 인스턴스가 좌표를 DB 에 올린다 (여기까진 정상)
//   ② SPD 스테퍼를 누른다 → GameConfigContext 인스턴스의 saveToDb({moveSpeed}) 가
//      `{...settingsRef.current, ...overrides}` 로 **자기가 마운트할 때 읽은 낡은 전체
//      설정**을 통째로 PUT 한다
//   ③ 서버는 JSONB `||` 병합이라 낡은 좌표가 방금 저장한 좌표를 덮는다. saveLocal 도
//      같이 돌아 localStorage 까지 되돌아간다 → 재접속하면 원래 자리
//
// GameConfigContext 는 이제 없다 — 이동속도는 hooks/useMoveSpeed.js 가
// 이 공유 설정 위에서 직접 읽고 쓴다. 위 ②의 saveToDb 이중 저장도 같이 사라졌다.
//
// 「전체를 보내는 저장」과 「인스턴스가 여럿」은 같이 두면 반드시 서로를 지운다.
// 인스턴스를 하나로 만드는 쪽이 옳다 — 저장 API 를 부분 저장으로 바꾸는 건 호출부
// 전부를 건드리는 큰 수술이고, 설정은 원래 앱 전역에 하나만 있어야 하는 물건이다.
import React, { createContext, useContext } from 'react';
import { useGameSettings } from '@hooks/useGameSettings';

const GameSettingsContext = createContext(null);

export const GameSettingsProvider = ({ children }) => {
  const value = useGameSettings();   // ← 앱 전체에서 **여기 한 번만** 부른다
  return (
    <GameSettingsContext.Provider value={value}>
      {children}
    </GameSettingsContext.Provider>
  );
};

/** settings · updateSetting · saveToDb · resetSettings — useGameSettings 와 같은 모양.
 *  `{ optional: true }` 면 Provider 밖(HUD 랩·미리보기)에서 던지지 않고 null 을 돌려준다. */
export const useSharedGameSettings = ({ optional = false } = {}) => {
  const ctx = useContext(GameSettingsContext);
  if (!ctx && !optional) throw new Error('useSharedGameSettings must be used within a GameSettingsProvider');
  return ctx;
};
